import RadioCircle from '../RadioCircle/RadioCircle'
import { toCurrencyFormat } from '@jagad/utils'
import {
  OuterContainer,
  InnerContainer,
  RadioWrapper,
  IDRPriceText,
  JIDRPriceText,
  JIDRLabel
} from './AmountOption.styles'

type IDRPriceProps = {
  price: number | string
}

const IDRPrice = ({ price }: IDRPriceProps) => {
  return (
    <IDRPriceText>
      {typeof price === 'number' ? `Rp${toCurrencyFormat(price)}` : `${price}`}
    </IDRPriceText>
  )
}

type JIDRPriceProps = {
  price: number
}

const JIDRPrice = ({ price }: JIDRPriceProps) => {
  return (
    <JIDRPriceText>
      <JIDRLabel>{`JIDR `}</JIDRLabel>
      {toCurrencyFormat(price)}
    </JIDRPriceText>
  )
}

export type AmountOptionProps = {
  idr: number | string
  jidr: number
  selected?: boolean
}

export default function AmountOption({ idr, jidr, selected }: AmountOptionProps) {
  return (
    <OuterContainer $selected={selected}>
      <InnerContainer $selected={selected}>
        <RadioWrapper>
          <RadioCircle checked={selected} />
        </RadioWrapper>
        {idr && <IDRPrice price={idr} />}
        <JIDRPrice price={jidr} />
      </InnerContainer>
    </OuterContainer>
  )
}
